export const flowPath = [
	{
		flow: 'Terms',
		url: '/termsAgreement',
		isReactPage: true,
	},
];
